import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { MagnetService } from '@mirage-projects/cw-commons';

@Injectable({ providedIn: 'root' })
export class RootPathRedirectGuard {
    constructor(
        private magnetService: MagnetService,
        private router: Router
    ) {}

    canActivate(): boolean {
        const rootPath = this.magnetService.isSite() ? '/projects' : '/panel';
        this.router.navigateByUrl(rootPath);
        return false;
    }
}
